<template>
  <div class="report-container">
    <h2>Report a Bug</h2>
    <p class="mb-6">
      Found something that is not working as expected? Please tell us what
      happened and we will investigate it right away.
    </p>

    <v-form @submit.prevent="submitReport">
      <v-text-field
        v-model="title"
        label="Issue title"
        hint="Example: SGDE converter crashes"
        persistent-hint
        outlined
        required
      ></v-text-field>

      <v-textarea
        v-model="details"
        label="Describe the problem"
        rows="6"
        auto-grow
        outlined
        required
      ></v-textarea>

      <v-btn
        color="primary"
        class="mt-4"
        :disabled="!canSubmit"
        prepend-icon="mdi-whatsapp"
        type="submit"
      >
        Send via WhatsApp
      </v-btn>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "ReportBug",
  data() {
    return {
      title: "",
      details: "",
    };
  },
  computed: {
    canSubmit() {
      return this.title.trim().length > 0 && this.details.trim().length > 0;
    },
  },
  methods: {
    submitReport() {
      if (!this.canSubmit) {
        return;
      }

      const summary = this.title.trim();
      const description = this.details.trim();
      const message = `Bug Report\n\nTitle: ${summary}\n\nDescription:\n${description}`;
      const whatsappUrl = `https://wa.me/96176469052?text=${encodeURIComponent(
        message
      )}`;

      window.open(whatsappUrl, "_blank");
    },
  },
};
</script>

<style scoped>
.report-container {
  max-width: 640px;
  margin: 0 auto;
  padding: 24px;
}
</style>
